var exports = {
  "Iz": "SegmentedControl__axepC8",
  "wB": "PlatformContents__s6zktY",
  "Xl": "CloneContainer__imJqCh",
  "W4": "CopyToClipboardIconButton__aZV1MG",
};

module.exports = exports;
